const footerColumns = [
  {
    title: "快速入口",
    links: [
      { label: "热帖排行", href: "#ranking" },
      { label: "吃瓜现场", href: "#comments" },
      { label: "话题入口", href: "#topics" },
      { label: "吃瓜速递", href: "#subscribe" },
    ],
  },
  {
    title: "热门分区",
    links: [
      { label: "演唱会现场", href: "#topics" },
      { label: "影视路透", href: "#topics" },
      { label: "综艺风向", href: "#topics" },
      { label: "电竞转会", href: "#topics" },
    ],
  },
  {
    title: "围观须知",
    links: [
      { label: "内容声明", href: "#top" },
      { label: "理性吃瓜公约", href: "#comments" },
      { label: "热帖收录规则", href: "#ranking" },
      { label: "意见反馈", href: "#subscribe" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="px-4 md:px-10 max-w-6xl mx-auto py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-line text-background-50 text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                黑料一区
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-background-300 max-w-sm">
              汇集吃瓜热帖与热门瓜的排行入口，火爆帖实时更新，把最受关注的八卦现场排好序摆在你面前，热瓜一网打尽。
            </p>
            <div className="mt-6 flex items-center gap-3">
              {["ri-weibo-line", "ri-wechat-line", "ri-douban-line", "ri-mail-line"].map(
                (icon) => (
                  <a
                    key={icon}
                    href="#top"
                    className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 hover:bg-accent-500 hover:text-foreground-950 text-background-200 cursor-pointer transition-colors"
                  >
                    <i className={`${icon} text-base`}></i>
                  </a>
                ),
              )}
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title} className="lg:col-span-2 lg:col-start-auto">
              <h4 className="text-sm font-medium text-background-50 tracking-wide">
                {column.title}
              </h4>
              <ul className="mt-5 space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-300 hover:text-accent-400 cursor-pointer transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-7 border-t border-background-50/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-background-300 leading-relaxed max-w-2xl">
            本站内容均为网络话题聚合与虚构演绎，不指向任何真实人物或事件，仅供吃瓜群众围观娱乐，请理性看待、
            切勿对号入座。
          </p>
          <p className="text-xs text-background-300 whitespace-nowrap">
            © 2026 黑料一区 · 吃瓜热帖排行
          </p>
        </div>
      </div>
    </footer>
  );
}